module.exports = __webpack_public_path__ + "img/bjr.dfa13e08.png";